/* eslint-disable no-restricted-syntax -- canonical brand hex values for theme defaults */
/**
 * DentXE product brand palette (official).
 * Deep navy is reserved for rare high-contrast moments — prefer teal + orange in UI.
 */
export const BRAND_PALETTE = {
  teal: '#0097a7',
  orange: '#ff8a00',
  navy: '#0b1d3a',
  white: '#ffffff',
} as const;
